import { render, staticRenderFns } from "./CustomsSettlementList.vue?vue&type=template&id=2e9c3a67&scoped=true"
import script from "./CustomsSettlementList.vue?vue&type=script&lang=js"
export * from "./CustomsSettlementList.vue?vue&type=script&lang=js"
import style0 from "./CustomsSettlementList.vue?vue&type=style&index=0&id=2e9c3a67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9c3a67",
  null
  
)

export default component.exports